export default __webpack_public_path__ + "static/media/Opificio-Bold.8190c458.ttf";